import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import * as XLSX from 'xlsx';
import {ConsultingService, LoaderService, ReportService} from '@app/shared/services';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {UtilsInjectable} from '@app/shared';
import { ReportPdfComponent } from '@app/components/report-pdf/report-pdf.component';

const EXCEL_EXTENSION = '.xlsx';

@Component({
  selector: 'app-purchase-vat-report',
  templateUrl: './purchase-vat-report.component.html',
  imports: [
    CommonModule, 
    FormsModule,
    PageHeaderComponent,
    ReportPdfComponent
  ],
  styleUrls: ['./purchase-vat-report.component.scss']
})

export class PurchaseVatReportComponent implements OnInit {


  @ViewChild('table') table?: ElementRef;
  user_rights: any;
  user_data: any;

  stock_data: any;
  closeResult = "";
  medicine: any;
  sale_return_quantity: any;
  sale_quantity = 0;
  fromdate = new Date();
  todate = new Date();
  start: any;
  limit: any;

  states: any[] = [];
  state_options: any[] = [];
  vat_state: any;
  vat_statecode: any;
  state_data: any;
  grand_total = 0;
  vat_total = 0;
  flood = 0;
  total_exclude = 0;
  total_include = 0;
  purchased: any;
  item_list: any;
  price_total = 0;
  net_total = 0;
  disc_total = 0;
  configer = {
    displayKey: "STATE_NAME",
    search: true,
    height: 'auto',
    placeholder: 'Select State',

    limitTo: 10,
    moreText: '.........',
    noResultsFound: 'No results found!',
    searchPlaceholder: 'Search',
    searchOnKey: 'STATE_NAME'
  }

  constructor(private loaderService: LoaderService,
              private modalService: NgbModal,
              public rest: ConsultingService,
              public report: ReportService,
              protected utils: UtilsInjectable,
  ) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.fromdate = new Date(this.fromdate.getFullYear(), this.fromdate.getMonth(), 1, 23, 59, 59);
    this.todate = new Date(this.todate.getFullYear(), this.todate.getMonth() + 1, 0, 23, 59, 59);
    this.listState();
    this.listVatReport();
  }

  public getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  public listVatReport() {
    const postData = {
      invoice_date_from: this.fromdate,
      invoice_date_to: this.todate,
      start: this.start,
      limit: this.limit
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.rest.listVatPurchaseReport(postData).subscribe((result: any) => {
      this.loaderService.display(false);
      if (result['status'] == 'success') {
        this.stock_data = result['data'];
        this.BalVatamount();
      } else {
        this.stock_data = []
        this.vat_total = 0
        this.flood = 0
        this.total_exclude = 0
        this.total_include = 0
        this.grand_total = 0
      }
    });
  }

  public purached_items(item: any) {

    const postData = {

      purchase_id: item.PURCHASE_ID
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.rest.getPurchase(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.purchased = result['data'];
        this.item_list = result['data'].PURCHASE;
        this.getSumpurchase();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  getSumpurchase() {
    let price = 0;
    let disc = 0;

    for (const item of this.item_list) {
      price = price + parseFloat(item.GROSS_AMOUNT);
      disc = disc + parseFloat(item.DISCOUNT);
    }
    this.price_total = price
    if (this.purchased.DISCOUNT) {
      this.net_total = price - this.purchased.DISCOUNT
    } else {
      this.net_total = price
    }
    this.disc_total = disc
  }

  public BalVatamount() {
    let i = 0
    let vat_total = 0;
    let total_exclude = 0;
    let total_include = 0;


    for (const data of this.stock_data) {
      vat_total = vat_total + parseFloat(data.PURCHASE_VAT_AMOUNT)
      total_exclude = total_exclude + parseFloat(data.TOTAL_EXCLUDE_VAT)
      total_include = total_include + parseFloat(data.TOTAL_INCLUDE_VAT)

      i = i + 1;
    }
    this.vat_total = (vat_total)
    this.total_exclude = (total_exclude)
    this.total_include = (total_include)
    this.grand_total = this.vat_total
  }

  public ExportToExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table?.nativeElement, {
      dateNF: 'dd/mm/yyyy;@',
      cellDates: true,
      raw: true
    });
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'Purchase_vat_report_' + new Date().getTime() + EXCEL_EXTENSION);

  }

  public listState() {
    this.states = [];
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.report.listState().subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.states = result['state']['data'];
        this.state_options = this.states;
        this.vat_state = this.state_options[18].STATE_ID;
        this.vat_statecode = this.state_options[18].TIN_NUMBER;
        this.setState();

        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);

      }
    });
  }

  public setState() {
    if (this.vat_state) {
      for (let index = 0; index < this.states.length; index++) {
        if (this.states[index].STATE_ID == this.vat_state) {
          this.state_data = this.states[index];
          break;
        }
      }
    }
  }

  protected opens(content: any) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: "col-md-12"
    }).result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason == ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason == ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}
